import { Route, Routes } from "react-router-dom";
import { useEffect, useState } from "react";

import AboutPage from "./Pages/AboutPage/AboutPage";
import Brightness4Icon from '@mui/icons-material/Brightness4';
import ContactPage from "./Pages/ContactPage";
import HomePage from "./Pages/HomePage/HomePage";
import { IconButton } from "@material-ui/core";
import MenuIcon from '@mui/icons-material/Menu';
import PortfolioPage from "./Pages/PortfolioPage";
import ResumePage from "./Pages/ResumePage";
import Sidebar from "./Components/Sidebar";
import Switch from '@material-ui/core/Switch';
import styled from "styled-components";

function App() {
  const [theme, setTheme] = useState('dark-theme');
  const [checked, setChecked] = useState(false);
  const [navToggle, setNavToggle] = useState(false);

  useEffect(()=>{
    document.documentElement.className = theme;
  }, [theme]);

  const themeToggler = () =>{
    if(theme === 'light-theme'){
      setTheme('dark-theme');
      setChecked(false)
    }else{
      setTheme('light-theme');
      setChecked(true)
    }
  }
  return (
    <div className="App">
        <Sidebar navToggle={navToggle}/>
        {/* theme Switcher */}
        <div className="theme">
          <div className="light-dark-mode">
            <div className="left-content">
              <Brightness4Icon />
            </div>
            <div className="right-content">
              <Switch 
                value=""
                size="medium"
                checked={checked}
                onClick={themeToggler}
                inputProps={{ 'aria-label': '' }}
              />
            </div>
          </div>
        </div>


        {/* menu */}
        <div className="ham-burger-menu">
          <IconButton onClick={() => setNavToggle(!navToggle)}>
            <MenuIcon />
          </IconButton>
        </div>
      <MainContentStyled>
        <Routes>
            <Route path="/" element={ <HomePage />}  />
            <Route path="/home" element={ <HomePage />} />
            <Route path="/about" element={ <AboutPage />} />
            <Route path="/resume" element={ <ResumePage />} />
            <Route path="/projects" element={ <PortfolioPage />} />
            <Route path="/contact" element={ <ContactPage />} />
        </Routes>
      </MainContentStyled>
    </div>
  );
}

const MainContentStyled = styled.div`
  position: relative;
  margin-left: 2.5rem;
  min-height: 100vh;
  @media only screen and (max-width: 1200px){
    margin-left: 0px;
  }
`;

export default App;
